export default "__VITE_ASSET__B63$w0qY__"